var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 253,
    viewBox: "0 0 246 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 145.5,
    r: 3.5,
    fill: "#F41C1C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 92.5,
    r: 3.5,
    fill: "#FE0550"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 58.5,
    r: 3.5,
    fill: "#64054B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 23.5,
    r: 3.5,
    fill: "#64054B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 226.5,
    r: 3.5,
    fill: "#FE0550"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 43.5,
    r: 3.5,
    fill: "#F41C1C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 36.5,
    r: 3.5,
    fill: "#EF96D6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 3.5,
    r: 3.5,
    fill: "#F41C1C"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 23.5,
    r: 3.5,
    fill: "#FE0550"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 16.5,
    r: 3.5,
    fill: "#EF96D6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 16.5,
    r: 3.5,
    fill: "#64054B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 226.5,
    r: 3.5,
    fill: "#64054B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 77.5,
    r: 3.5,
    fill: "#64054B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 206.5,
    r: 3.5,
    fill: "#64054B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 185.5,
    r: 3.5,
    fill: "#64054B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 164.5,
    r: 3.5,
    fill: "#F41C1C"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 214.5,
    r: 3.5,
    fill: "#F41C1C"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 107.5,
    r: 3.5,
    fill: "#FE0550"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 107.5,
    r: 3.5,
    fill: "#EF96D6"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 213.5,
    r: 3.5,
    fill: "#EF96D6"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 192.5,
    r: 3.5,
    fill: "#EF96D6"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 249.5,
    r: 3.5,
    fill: "#F41C1C"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 62.5,
    r: 3.5,
    fill: "#FE0550"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.112,
    cy: 130.5,
    r: 53.2895,
    fill: "#1C5D99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1325_11409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.241 116.39L118.156 147.475L103.908 133.228L107.561 129.575L118.156 140.144L145.589 112.737L149.241 116.39Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.836 130.5C191.836 166.308 162.808 195.336 127 195.336C91.1923 195.336 62.1645 166.308 62.1645 130.5C62.1645 94.6923 91.1923 65.6645 127 65.6645C162.808 65.6645 191.836 94.6923 191.836 130.5Z",
    stroke: "#1C5D99",
    strokeWidth: 5.32895
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1325_11409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.1711,
    height: 62.1711,
    fill: "white",
    transform: "translate(95.0273 98.5273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectSvg);
export default __webpack_public_path__ + "static/media/correctSvg.46274cfbcc40f874f96f9fb196766837.svg";
export { ForwardRef as ReactComponent };